import * as yup from 'yup';

function email(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_IS_INVALID',
        defaultMessage: 'Email is invalid',
      }),
    )
    .required(
      formatMessage({
        id: 'EMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Email is required',
      }),
    );
}

function locationEmail(formatMessage) {
  return yup
    .string()
    .transform(value => (value === '' || value == null ? undefined : value))
    .optional()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_IS_INVALID',
        defaultMessage: 'Email is invalid',
      }),
    );
}

export default function validationSchema(formatMessage, isLocationScope) {
  if (isLocationScope) {
    return yup
      .object({
        email: locationEmail(formatMessage),
      })
      .required();
  }
  return yup
    .object({
      email: email(formatMessage),
    })
    .required();
}
